import { forwardRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Toast } from "../../types/dataTypes";

interface CustomToastProps extends Toast {
  onToastClose: Function;
  action?: any;
  autoHideDuration?: number;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomToast = (props: CustomToastProps) => {
  const {
    isToastShown,
    onToastClose,
    toastKey,
    toastMessage,
    toastSeverity,
    action,
    autoHideDuration = 2000,
  } = props;

  let handleClose = () => {
    onToastClose();
  };

  if (toastSeverity === "custom") {
    return (
      <Snackbar
        autoHideDuration={autoHideDuration}
        open={isToastShown}
        onClose={handleClose}
        key={toastKey}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        action={action}
        message={toastMessage}
        sx={{
          height: "116px",
          width: "300px",
          "& .MuiSnackbarContent-message": {
            lineHeight: "20px",
            fontSize: "14px",
          },
          "& .MuiSnackbarContent-root": {
            borderRadius: "8px",
          },
        }}
      />
    );
  } else {
    return (
      <Snackbar
        autoHideDuration={autoHideDuration}
        open={isToastShown}
        onClose={handleClose}
        key={toastKey}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Alert
          severity={toastSeverity}
          onClose={handleClose}
          sx={{
            fontSize: "14px",
            padding: "12px",
            display: "flex",
            alignItems: "center",
            borderRadius: "8px",
            fontWeight: 400,
            maxWidth: 500,
            "& .MuiAlert-action": {
              margin: 0,
              paddingLeft: 0,
              height: "16px",
              width: "16px",
              "& .MuiSvgIcon-root": {
                fontSize: "16px",
              },
            },
            "& .MuiAlert-icon": {
              padding: 0,
              marginRight: "8px",
              height: "24px",
              width: "24px",
              "& svg": {
                fontSize: "24px",
              },
            },
            "& .MuiAlert-message": {
              padding: 0,
              marginRight: "8px",
              lineHeight: "20px",
            },
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    );
  }
};

export default CustomToast;
